export default __webpack_public_path__ + "static/media/js.9617a856.svg";